module.exports = __webpack_public_path__ + "static/media/register_kindergartens.d613b880.png";